import { Canvas,useFrame } from '@react-three/fiber';
import { Environment,OrbitControls,useGLTF } from '@react-three/drei';
import { useEffect,useRef } from 'react';
import * as THREE from 'three';

const Marquardt = () => {
  const { scene } = useGLTF('/Marquardt.glb');
  const ref = useRef();

  useEffect(() => {
    scene.traverse((child) => {
      if (child.isMesh) {
        child.material.side = THREE.FrontSide;
        child.material.needsUpdate = true;
      }
    });
  }, [scene]);

  const Look = () => {
    const mouse = useRef({ x: 0, y: 0 });
    const target = new THREE.Vector3();
    const fakeObj = new THREE.Object3D();

    useEffect(() => {
      const move = (e) => {
        mouse.current.x = (e.clientX / window.innerWidth) * 2 - 1;
        mouse.current.y = -(e.clientY / window.innerHeight) * 2 + 1;
      };

      window.addEventListener('mousemove', move);
      return () => window.removeEventListener('mousemove', move);
    }, []);

    useFrame(() => {
      if (!ref.current) return;

      target.set(
        mouse.current.x * 5,
        mouse.current.y * 3,
        2
      );

      fakeObj.position.copy(ref.current.position);
      fakeObj.lookAt(target);

      ref.current.quaternion.slerp(fakeObj.quaternion, 0.05);
    });

    return null;
  };

  return (
    <>
      <primitive 
        ref={ref}
        object={scene}
        scale={2}
        position={[-2, 0, 0]}
      />
      <Look/>
    </>
  )
};

const MarquardtViewer = () => {
  return (
    <Canvas 
      camera={{
        fov:95,
        position: [0, 0, 5],
      }}
    >
      <OrbitControls
        enableZoom={true}
      />
      <Environment preset={'studio'} />
      <Marquardt/>
    </Canvas>
  )
};

export default MarquardtViewer;